import React, { useEffect } from 'react';
import {useDropzone} from 'react-dropzone';
import { useInternationalization } from '../../../features/i18n';

function FileDropzone({
  onChange = (e) => { console.log(e) },
  accept = 1
}) {
  const { translate } = useInternationalization()
  const acceptConverted =
    accept === 3 ? 'application/pdf' :
    accept === 4 ? 'video/*' :
    accept === 5 ? 'audio/*' :
    false

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps
  } = useDropzone(acceptConverted ? {
    maxFiles: 1,
    accept: acceptConverted
  } : {
    maxFiles: 1
  });

  useEffect(() => {
    onChange(acceptedFiles)
    //eslint-disable-next-line
  }, [acceptedFiles])

  const acceptedFileItems = acceptedFiles.map(file => (
    <li key={file.path}>
      <p className="font-bold text-primary underline mr-4 text-sm">
        {file.path} - {file.size} bytes
      </p>
    </li>
  ));

  //eslint-disable-next-line
  const fileRejectionItems = fileRejections.map(({ file, errors  }) => {
   return (
     <li key={file.path}>
        <p className="font-bold text-primary underline mr-4 text-sm">
          {file.path} - {file.size} bytes
        </p>
        <ul>
          {errors.map(e => <li key={e.code} className="text-sm text-red-600">{e.message}</li>)}
        </ul>
     </li>
   )
  });


  return (
    <section>
      <aside className="mb-4">
        {/* <h4>Accepted files</h4> */}
        <ul className="mb-4">{acceptedFileItems}</ul>
        {/* <h4>Rejected files</h4> */}
        {/* <ul>{fileRejectionItems}</ul> */}
      </aside>
      <div {...getRootProps({ className: 'dropzone border border-dashed rounded p-6 flex items-center justify-center cursor-pointer' })}>
        <input {...getInputProps()} />
        <p className="text-gray-999 underline text-sm">{translate('GENERAL', 'choose_file')}</p>
      </div>
    </section>
  );
}

export default FileDropzone
